import { useState } from 'react';
import {
	Box,
	Typography,
	Switch,
	IconButton,
	Drawer,
	TextField,
	FormControlLabel,
	CircularProgress,
	Button,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

const CategoriesDrawer = ({
	open,
	onClose,
	onSubmit,
	formData,
	onChange,
	isMobile,
	editMode = false,
}) => {
	const theme = useTheme();
	const [loading, setLoading] = useState(false);

	const handleSubmit = async () => {
		setLoading(true);
		try {
			await onSubmit();
			setLoading(false);
		} catch (error) {
			console.error('Error saving category:', error);
			setLoading(false);
		}
	};

	return (
		<Drawer
			anchor={'right'}
			open={open}
			onClose={onClose}
			PaperProps={{
				sx: {
					width: isMobile ? '100%' : '400px',
					maxHeight: isMobile ? '90vh' : '100%',
					borderRadius: isMobile ? '16px 16px 0 0' : '0',
					padding: 0,
					zIndex: 1300,
				},
			}}
		>
			<Box
				sx={{
					p: 0,
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				{/* Drawer Header */}
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						borderBottom: `1px solid ${theme.palette.divider}`,
						p: 2,
					}}
				>
					<Typography variant='h6'>
						{editMode ? 'Edit Category' : 'Add New Category'}
					</Typography>
					<IconButton onClick={onClose} edge='end' aria-label='close'>
						<CloseIcon />
					</IconButton>
				</Box>

				{/* Form Container */}
				<Box
					sx={{
						p: 2,
						flexGrow: 1,
						overflowY: 'auto',
					}}
				>
					<TextField
						fullWidth
						margin='normal'
						label='Category Name'
						name='displayName'
						value={formData.displayName}
						onChange={onChange}
						required
					/>

					<TextField
						fullWidth
						margin='normal'
						label='Description'
						name='description'
						value={formData.description}
						onChange={onChange}
					/>
          
					<FormControlLabel
						control={
							<Switch
								checked={formData.active}
								onChange={(e) => {
									onChange({
										target: {
											name: 'active',
											value: e.target.checked,
										},
									});
								}}
								color='primary'
							/>
						}
						label='Active'
						margin='normal'
						sx={{ mt: 2 }}
					/>

					<Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
						<Button
							variant='outlined'
							onClick={onClose}
							sx={{ mr: 1 }}
							disabled={loading}
						>
							Cancel
						</Button>
						<Button
							variant='contained'
							onClick={handleSubmit}
							disabled={loading || !formData.displayName}
						>
							{loading ? (
								<CircularProgress size={24} />
							) : editMode ? (
								'Save Changes'
							) : (
								'Create Category'
							)}
						</Button>
					</Box>
				</Box>
			</Box>
		</Drawer>
	);
};

export default CategoriesDrawer;
